import { render, staticRenderFns } from "./SystemMod.vue?vue&type=template&id=37762a58&scoped=true"
import script from "./SystemMod.vue?vue&type=script&lang=js"
export * from "./SystemMod.vue?vue&type=script&lang=js"
import style0 from "./SystemMod.vue?vue&type=style&index=0&id=37762a58&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37762a58",
  null
  
)

export default component.exports